export default [
  {
    title: "Merchant",
    icon: "MapIcon",
    tagVariant: "success",
    children: [
      {
        title: "Company",
        route: "Companies-list",
        resource: "Companies",
        action: "View",
      },
      {
        title: "Merchant",
        route: "Merchants-list",
        resource: "Merchants",
        action: "View",
      },
      {
        title: "Hosting Page Configuration",
        route: "MerchantsHostingPage-list",
        resource: "MerchantsHostingPage",
        action: "View",
      },
    ],
  },
];
